"use strict";

exports.__esModule = true;
exports.escapeRegExp = exports.INVALID_REGEX_CHARACTERS = void 0;
var INVALID_REGEX_CHARACTERS = exports.INVALID_REGEX_CHARACTERS = /[-\\^$*+?.()|[\]{}]/g;
var escapeRegExp = exports.escapeRegExp = function escapeRegExp(input) {
  return input.replace(INVALID_REGEX_CHARACTERS, "\\$&");
};